<template>
  <div class="sm:w-full md:w4/5 lg:w-3/5 mx-auto md:p-6">
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <!-- Header -->
      <div class="bg-gradient-to-r from-red-500 to-pink-500 px-6 py-4">
        <h2 class="text-xl font-semibold text-white">Add New Friend</h2>
        <p class="text-red-100 text-sm mt-1">Add someone special to your present planning list...</p>
      </div>

      <!-- Form Content -->
      <div class="p-6 space-y-6">
        <!-- Basic Information Section -->
        <div class="space-y-4">
          <h3 class="text-lg font-semibold text-gray-900 border-b border-gray-200 pb-2">Basic Information</h3>
          
          <!-- Name Field -->
          <div>
            <label for="addfriendName" class="block text-sm font-medium text-gray-700 mb-2">
              Name
            </label>
            <input
              v-model="friendForm.name"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200 bg-gray-50 hover:bg-white"
              id="addfriendName"
              placeholder="Johnny Examplerson"
              maxlength="100"
>
          </div>

          <!-- Email Field -->
          <div>
            <label for="addfriendDescription" class="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <input
              v-model="friendForm.email"
              type="email"
              placeholder="their@email.com"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200 bg-gray-50 hover:bg-white"
              id="addfriendDescription"
              maxlength="254"
>
          </div>
        </div>

        <!-- Birthday Section -->
        <div class="bg-pink-50 rounded-lg p-4 border border-pink-200">
          <div class="flex items-center mb-3">
            <div class="w-8 h-8 bg-pink-100 rounded-full flex items-center justify-center mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-pink-600">
                <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" /><path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1" /><path d="M2 21h20" /><path d="M7 8v3" /><path d="M12 8v3" /><path d="M17 8v3" /><path d="M7 4h.01" /><path d="M12 4h.01" /><path d="M17 4h.01" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900">Birthday</h3>
          </div>
          
          <div class="mb-4">
            <label for="addfriendBirthday" class="block text-sm font-medium text-gray-700 mb-2">
              Birthday Date
            </label>
            <input 
              v-model="friendForm.birthday" 
              type="date"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200 bg-white"
              id="addfriendBirthday"
>
          </div>

          <div class="flex items-start space-x-3">
            <input 
              id="reminder" 
              type="checkbox" 
              v-model="friendForm.reminder" 
              :disabled="birthdaySet == false"
              class="mt-1 h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
>
            <div class="flex-1">
              <label 
                for="reminder"
                :class="birthdaySet ? 'text-gray-900' : 'text-gray-400'"
                class="block text-sm font-medium"
>
                Remind me before their birthday
              </label>
              <p class="text-xs text-gray-500 mt-1">
                We'll send you a reminder 2 weeks before {{ reminderName }} birthday
              </p>
            </div>
          </div>
        </div>

        <!-- Anniversary Section -->
        <div class="bg-purple-50 rounded-lg p-4 border border-purple-200">
          <div class="flex items-center mb-3">
            <div class="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-purple-600">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900">Anniversary</h3>
          </div>
          
          <div class="mb-4">
            <label for="friendAnniversary" class="block text-sm font-medium text-gray-700 mb-2">
              Anniversary Date
            </label>
            <input 
              v-model="friendForm.anniversary" 
              type="date"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200 bg-white"
              id="friendAnniversary"
>
          </div>

          <div class="flex items-start space-x-3">
            <input 
              id="friendAnniversaryReminder" 
              type="checkbox" 
              v-model="friendForm.anniversaryReminder"
              :disabled="anniversarySet == false" 
              class="mt-1 h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
>
            <div class="flex-1">
              <label 
                for="friendAnniversaryReminder"
                :class="anniversarySet ? 'text-gray-900' : 'text-gray-400'"
                class="block text-sm font-medium"
>
                Remind me before this anniversary
              </label>
              <p class="text-xs text-gray-500 mt-1">
                We'll send you a reminder 2 weeks before your anniversary
              </p>
            </div>
          </div>
        </div>

        <!-- Notification Section -->
        <div class="bg-blue-50 rounded-lg p-4 border border-blue-200">
          <div class="flex items-center mb-3">
            <div class="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-blue-600">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900">Invitation</h3>
          </div>

          <div class="flex items-start space-x-3">
            <input 
              id="notifyRegistration" 
              type="checkbox" 
              v-model="friendForm.notifyRegistration" 
              :disabled="emailSet == false"
              class="mt-1 h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
>
            <div class="flex-1">
              <label 
                for="notifyRegistration"
                :class="emailSet ? 'text-gray-900' : 'text-gray-400'"
                class="block text-sm font-medium"
>
                Let them know I've added them
              </label>
              <p class="text-xs text-gray-500 mt-1">
                We will send {{ notifyName }} an email letting them know <strong>someone</strong> has added them on Present Planner, and invite them to join. They will not see your name or email.
              </p>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
          <button 
            @click="$router.go(-1)" 
            type="button"
            class="px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-colors duration-200"
>
            Cancel
          </button>
          <button 
            @click="createFriend" 
            type="button"
            class="px-6 py-2.5 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors duration-200"
>
            Add Friend
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';

import { createFriend } from '../graphql/mutations';

export default {
  name: 'FriendAdd',
  data() {
    return {
      friendForm: {
        name: '',
        reminder: false,
        anniversaryReminder: false,
        notifyRegistration: false,
        email: '',
      },
      emailSet: false,
      birthdaySet: false,
      anniversarySet: false,
    }
  },
  computed: {
    reminderName() {
      return this.friendForm.name === '' ? 'their' : this.friendForm.name + '\'s';
    },
    notifyName() {
      return this.friendForm.name === '' ? 'them' : this.friendForm.name;
    }
  },
  watch: {
    'friendForm.email': function (newVal, oldVal) {
      const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newVal);
      this.friendForm.notifyRegistration = valid;
      this.emailSet = valid;
    },
    'friendForm.birthday': function (newVal, oldVal) {
      if (newVal) {
        this.friendForm.reminder = true;
        this.birthdaySet = true;
      } else {
        this.friendForm.reminder = false;
        this.birthdaySet = false;
      }
    },
    'friendForm.anniversary': function (newVal, oldVal) {
      if (newVal) {
        this.friendForm.anniversaryReminder = true;
        this.anniversarySet = true;
      } else {
        this.friendForm.anniversaryReminder = false;
        this.anniversarySet = false;
      }
    },
  },
  methods: {
    async createFriend() {
      var { name, email, birthday, reminder, anniversary, anniversaryReminder, notifyRegistration } = this.friendForm
      if (!birthday) { birthday = null };
      if (!anniversary) { anniversary = null };
      if (!email) { email = null };
      if (!name) return;

      const friend = { name, email, birthday, reminder, anniversary, anniversaryReminder, notifyRegistration };
      try {
        const response = await API.graphql({ query: createFriend, variables: { input: friend }, });
        this.$router.go(-1)
      } catch (error) {
      }
    },
  }
}
</script>